import React from 'react';
import './clearfix.scss';

export default props => (
  <div className="clearfix"></div>
);
